import { useLocales } from '@shared/locales'
import { Button, Flex } from 'antd'
import { Add } from 'iconsax-react'
import { useState } from 'react'

import { AddEditTask } from './AddEditTask'

export const TasksHeader = () => {
  const { t } = useLocales()

  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Flex justify="flex-end">
      <Button
        onClick={() => setIsModalOpen(true)}
        icon={<Add size={16} />}
        type="primary"
      >
        {t('task.add_task')}
      </Button>

      {isModalOpen && (
        <AddEditTask open onCancel={() => setIsModalOpen(false)} />
      )}
    </Flex>
  )
}
